import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { UserDTO } from '../types';

export const useSignupForm = () => {
  const {
    control,
    handleSubmit,
    watch,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<UserDTO>({
    mode: 'all',
  });

  const password = watch('password');
  const password2 = watch('password2');
  const uid = watch('uid');
  const birthday = watch('birthday');

  // password가 변경되면 password2 재검증
  useEffect(() => {
    if (password2) {
      trigger('password2');
    }
  }, [password, trigger, password2]);

  return {
    control,
    handleSubmit,
    watch,
    clearErrors,
    trigger,
    errors,
    password,
    password2,
    uid,
    birthday,
  };
};
